import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_left_nav = _resolveComponent("app-left-nav")!
  const _component_app_bottom_nav = _resolveComponent("app-bottom-nav")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_checked = _resolveComponent("checked")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_star = _resolveComponent("star")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_app_top_nav = _resolveComponent("app-top-nav")!
  const _component_OpportunitiesList = _resolveComponent("OpportunitiesList")!
  const _component_app_loader_opportunities = _resolveComponent("app-loader-opportunities")!
  const _component_app_business_right_nav = _resolveComponent("app-business-right-nav")!
  const _component_app_opportunities_list_nav = _resolveComponent("app-opportunities-list-nav")!
  const _component_app_right_nav = _resolveComponent("app-right-nav")!
  const _component_app_main_layout = _resolveComponent("app-main-layout")!

  return (_openBlock(), _createBlock(_component_app_main_layout, null, {
    left: _withCtx(() => [
      _createVNode(_component_app_left_nav)
    ]),
    "bottom-nav": _withCtx(() => [
      _createVNode(_component_app_bottom_nav)
    ]),
    top: _withCtx(() => [
      _createVNode(_component_app_top_nav, { padded: "" }, {
        left: _withCtx(() => [
          false
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "text",
                plain: "",
                circle: "",
                "is-all-borderless": "",
                icon: "el-icon-back"
              }))
            : _createCommentVNode("", true)
        ]),
        center: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", { "nav-title": "" }, "Opportunities", -1)
        ]))]),
        right: _withCtx(() => [...(_cache[1] || (_cache[1] = []))]),
        bottom: _withCtx(() => [
          _createVNode(_component_el_menu, {
            "size-2": "",
            "default-active": _ctx.activeIndex,
            router: "",
            mode: "horizontal"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "/opportunities?isArchived=false" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_checked)
                    ]),
                    _: 1
                  }),
                  _cache[2] || (_cache[2] = _createElementVNode("span", null, "Active", -1))
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "/opportunities?isArchived=true" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_star)
                    ]),
                    _: 1
                  }),
                  _cache[3] || (_cache[3] = _createElementVNode("span", null, "Archived", -1))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["default-active"])
        ]),
        _: 1
      })
    ]),
    middle: _withCtx(() => [
      _createElementVNode("div", null, [
        _createVNode(_component_OpportunitiesList, { opportunities: _ctx.opportunities }, null, 8, ["opportunities"]),
        _createVNode(_component_app_loader_opportunities, {
          style: {"margin-top":"8px"},
          loading: _ctx.loading,
          resources: _ctx.opportunities,
          content: "Can't find any opportunities."
        }, null, 8, ["loading", "resources"])
      ])
    ]),
    right: _withCtx(() => [
      _createVNode(_component_app_right_nav, null, {
        default: _withCtx(() => [
          _createVNode(_component_app_business_right_nav),
          _createVNode(_component_app_opportunities_list_nav)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}